// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1cotO","file":"styles_file__1M2mK"};